import { FeatureText } from '@cxc/react-hydro-components';
import styles from './style.module.scss';
import { useAtom } from 'jotai';
import { aemContent } from '../state/globalState';
import { htmlReactParserWrapper } from '../utils/htmlReactParserWrapper';
export default function InfoDescription() {
    const [aem] = useAtom(aemContent);
    const heading = htmlReactParserWrapper(aem?.['section-1']?.['props']?.['heading'] || null);
    const body = htmlReactParserWrapper(aem?.['section-1']?.['props']?.['text'] || null);
    const disclosureTitle = htmlReactParserWrapper(aem?.['section-1']?.['props']?.['popOverButtonText'] || null);
    const disclosureBody =  aem?.['section-1']?.['props']?.['disclosures']?.[0]?.disclosureKey || "" + '  ' + htmlReactParserWrapper(aem?.['section-1']?.['props']?.['disclosures']?.[0]?.disclosure?.disclosureText || null);  
    return (
        <div className="fds-layout-grid">
             <div className={`fds-align--center ${styles.mrgTop22} ${styles.mrgBtm32} fds-layout-grid__cell--span-12`}>
                <FeatureText
                    id="comparison-table"
                    bodyText={body}
                    disclosureBody={disclosureBody}
                    disclosureTitle={disclosureTitle}
                    headingText={heading}
                    headingTextHtmlTag="h3"
                    type="headingLarge"
                />
            </div>
        </div>
    );
}
